import styled from 'styled-components';

export default function CommonContainer({ children }) {
    return <StyledContainer>{children}</StyledContainer>;
}
const StyledContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    padding: 40px 50px;
    background-color: #ffffff;
    border-radius: 32px;
    gap: 32px;

    @media (max-width: 768px) {
        padding: 40px 16px;
    }
`;
